export const agentOfficeDropdownValues = {
	packageType: [
		{ name: "Bronze", value: "Bronze" },
		{ name: "Silver", value: "Silver" },
		{ name: "Gold", value: "Gold" },
	],
};

export const agentOfficeSetupConstants = {
	GET_AGENT_OFFICES_REQUEST: "AGENT_OFFICE_SETUP_GET_AGENT_OFFICES_REQUEST",
	GET_AGENT_OFFICES_SUCCESS: "AGENT_OFFICE_SETUP_GET_AGENT_OFFICES_SUCCESS",
	GET_AGENT_OFFICES_FAILURE: "AGENT_OFFICE_SETUP_GET_AGENT_OFFICES_FAILURE",

	GET_PRIMARY_CONTACT_SUCCESS: "GET_PRIMARY_CONTACT_SUCCESS",
	GET_PRIMARY_CONTACT_ERROR: "GET_PRIMARY_CONTACT_ERROR",

	ADD_AGENT_FORM_SUCCESS: "ADD_AGENT_FORM_SUCCESS",
	ADD_AGENT_FORM_ERROR: "ADD_AGENT_FORM_ERROR",

	ADD_AGENT_OFFICE_DOCUMENT_REQUEST: "ADD_AGENT_OFFICE_DOCUMENT_REQUEST",
	ADD_AGENT_OFFICE_DOCUMENT_SUCCESS: "ADD_AGENT_OFFICE_DOCUMENT_SUCCESS",
	ADD_AGENT_OFFICE_DOCUMENT_ERROR: "ADD_AGENT_OFFICE_DOCUMENT_ERROR",

	EDIT_AGENT_OFFICE_DOCUMENT_REQUEST: "EDIT_AGENT_OFFICE_DOCUMENT_REQUEST",
	EDIT_AGENT_OFFICE_DOCUMENT_SUCCESS: "EDIT_AGENT_OFFICE_DOCUMENT_SUCCESS",
	EDIT_AGENT_OFFICE_DOCUMENT_ERROR: "EDIT_AGENT_OFFICE_DOCUMENT_ERROR",

	SAVE_EDIT_AGENT_FORM_SUCCESS: "SAVE_EDIT_AGENT_FORM_SUCCESS",

	GET_AGENTS_SUCCESS: "GET_AGENTS_SUCCESS",
	GET_AGENTS_ERROR: "GET_AGENTS_ERROR",

	GET_MERCHANT_LIST_SUCCESS: "GET_MERCHANT_LIST_SUCCESS",
	GET_MERCHANT_LIST_ERROR: "GET_MERCHANT_LIST_ERROR",

	GET_NOTIFICATION_TEMPLATES_SUCCESS: "GET_NOTIFICATION_TEMPLATES_SUCCESS",
	GET_NOTIFICATION_TEMPLATES_ERROR: "GET_NOTIFICATION_TEMPLATES_ERROR",

	GET_E_SIGN_ACCOUNTS_SUCCESS: "GET_E_SIGN_ACCOUNTS_SUCCESS",
	GET_E_SIGN_ACCOUNTS_ERROR: "GET_E_SIGN_ACCOUNTS_ERROR",

	SAVE_NOTIFICATION_TEMPLATE_FORM_SUCCESS:
		"SAVE_NOTIFICATION_TEMPLATE_FORM_SUCCESS",
	SAVE_NOTIFICATION_TEMPLATE_FORM_ERROR:
		"SAVE_NOTIFICATION_TEMPLATE_FORM_ERROR",

	GET_BRANDING_LOGO_SUCCESS: "GET_BRANDING_LOGO_SUCCESS",
	GET_BRANDING_LOGO_ERROR: "GET_BRANDING_LOGO_ERROR",

	GET_BRANDING_COLORS_SUCCESS: "GET_BRANDING_COLORS_SUCCESS",
	GET_BRANDING_COLORS_ERROR: "GET_BRANDING_COLORS_ERROR",

	GET_CHECK_OFFICE_NAME_SUCCESS: "GET_CHECK_OFFICE_NAME_SUCCESS",
	GET_CHECK_OFFICE_NAME_ERROR: "GET_CHECK_OFFICE_NAME_ERROR",

	GET_EDIT_ADDITIONAL_FEE_DOCUMENTS_REQUEST:
		"GET_EDIT_ADDITIONAL_FEE_DOCUMENTS_REQUEST",
	GET_EDIT_ADDITIONAL_FEE_DOCUMENTS_SUCCESS:
		"GET_EDIT_ADDITIONAL_FEE_DOCUMENTS_SUCCESS",
	GET_EDIT_ADDITIONAL_FEE_DOCUMENTS_ERROR:
		"GET_EDIT_ADDITIONAL_FEE_DOCUMENTS_ERROR",

	GET_FEE_TEMPLATES_REQUEST: "GET_FEE_TEMPLATES_REQUEST",
	GET_FEE_TEMPLATES_SUCCESS: "GET_FEE_TEMPLATES_SUCCESS",
	GET_FEE_TEMPLATES_ERROR: "GET_FEE_TEMPLATES_ERROR",

	REODER_FEE_TEMPLATES_REQUEST: "REODER_FEE_TEMPLATES_REQUEST",
	REODER_FEE_TEMPLATES_SUCCESS: "REODER_FEE_TEMPLATES_SUCCESS",
	REODER_FEE_TEMPLATES_ERROR: "REODER_FEE_TEMPLATES_ERROR",

	COPY_FEE_TEMPLATE_SUCCESS: "COPY_FEE_TEMPLATE_SUCCESS",
	COPY_FEE_TEMPLATE_ERROR: "COPY_FEE_TEMPLATE_ERROR",

	CHANGE_FEE_TEMPLATE_STATUS_REQUEST: "CHANGE_FEE_TEMPLATE_STATUS_REQUEST",
	CHANGE_FEE_TEMPLATE_STATUS_SUCCESS: "CHANGE_FEE_TEMPLATE_STATUS_SUCCESS",
	CHANGE_FEE_TEMPLATE_STATUS_ERROR: "CHANGE_FEE_TEMPLATE_STATUS_ERROR",

	CHANGE_ADDITIONAL_FEE_TEMPLATE_STATUS_REQUEST:
		"CHANGE_ADDITIONAL_FEE_TEMPLATE_STATUS_REQUEST",
	CHANGE_ADDITIONAL_FEE_TEMPLATE_STATUS_SUCCESS:
		"CHANGE_ADDITIONAL_FEE_TEMPLATE_STATUS_SUCCESS",
	CHANGE_ADDITIONAL_FEE_TEMPLATE_STATUS_ERROR:
		"CHANGE_ADDITIONAL_FEE_TEMPLATE_STATUS_ERROR",

	DELETE_FEE_TEMPLATE_REQUEST: "DELETE_FEE_TEMPLATE_REQUEST",
	DELETE_FEE_TEMPLATE_SUCCESS: "DELETE_FEE_TEMPLATE_SUCCESS",
	DELETE_FEE_TEMPLATE_ERROR: "DELETE_FEE_TEMPLATE_ERROR",

	SAVE_TSYS_ACCOCUNT_REQUEST: "SAVE_TSYS_ACCOCUNT_REQUEST",
	SAVE_TSYS_ACCOCUNT_SUCCESS: "SAVE_TSYS_ACCOCUNT_SUCCESS",
	SAVE_TSYS_ACCOCUNT_ERROR: "SAVE_TSYS_ACCOCUNT_ERROR",

	SAVE_RISERV_ACCOUNT_REQUEST: "SAVE_RISERV_ACCOUNT_REQUEST",
	SAVE_RISERV_ACCOUNT_SUCCESS: "SAVE_RISERV_ACCOUNT_SUCCESS",
	SAVE_RISERV_ACCOUNT_ERROR: "SAVE_RISERV_ACCOUNT_ERROR",

	GET_TSYS_CREDENTIALS_REQUEST: "GET_TSYS_CREDENTIALS_REQUEST",
	GET_TSYS_CREDENTIALS_SUCCESS: "GET_TSYS_CREDENTIALS_SUCCESS",
	GET_TSYS_CREDENTIALS_ERROR: "GET_TSYS_CREDENTIALS_ERROR",

	GET_FD_CREDENTIALS_REQUEST: "GET_FD_CREDENTIALS_REQUEST",
	GET_FD_CREDENTIALS_SUCCESS: "GET_FD_CREDENTIALS_SUCCESS",
	GET_FD_CREDENTIALS_ERROR: "GET_FD_CREDENTIALS_ERROR",

	GET_EDIT_MONTHLY_FEE_DOCUMENTS_REQUEST:
		"GET_EDIT_MONTHLY_FEE_DOCUMENTS_REQUEST",
	GET_EDIT_MONTHLY_FEE_DOCUMENTS_SUCCESS:
		"GET_EDIT_MONTHLY_FEE_DOCUMENTS_SUCCESS",
	GET_EDIT_MONTHLY_FEE_DOCUMENTS_ERROR:
		"GET_EDIT_MONTHLY_FEE_DOCUMENTS_ERROR",

	CHANGE_MONTHLY_FEE_TEMPLATE_STATUS_REQUEST:
		"CHANGE_MONTHLY_FEE_TEMPLATE_STATUS_REQUEST",
	CHANGE_MONTHLY_FEE_TEMPLATE_STATUS_SUCCESS:
		"CHANGE_MONTHLY_FEE_TEMPLATE_STATUS_SUCCESS",
	CHANGE_MONTHLY_FEE_TEMPLATE_STATUS_ERROR:
		"CHANGE_MONTHLY_FEE_TEMPLATE_STATUS_ERROR",
};
